

const defOpt = {
  el: null,
  onDragIn() {},
  onDragOut() {},
  onDrop() {}
}

export default class DragUploadHelper {

  constructor(opt) {
    this.opt = Object.assign({}, defOpt, opt);
    let el = this.opt.el;

    // check out all drag events:
    // https://developer.mozilla.org/en-US/docs/Web/Events/dragenter

    // NOTE:
    // dragstart, dragend, dragexit is trigged from dragging element, not the target element. 

    // IMPORTANT:
    // In order to have the drop event occur on a element, the 'dragenter' and 'dragover' events MUST be canceled.

    // cancel 'dragover' event so that 'drop' event will be triggered onece user has dropped.
    el.addEventListener('dragover', this.stopDefaultPropagation);

    el.addEventListener('drag', this.stopDefaultPropagation);
    el.addEventListener('dragstart', this.stopDefaultPropagation);
    el.addEventListener('dragend', this.stopDefaultPropagation);
    el.addEventListener('dragexit', this.stopDefaultPropagation);

    this._onDragInListener = this.onDragIn.bind(this);
    this._onDragOutListener = this.onDragOut.bind(this);
    this._onDropListener = this.onDrop.bind(this);

    el.addEventListener('dragenter', this._onDragInListener);
    el.addEventListener('dragleave', this._onDragOutListener);
    el.addEventListener('drop', this._onDragOutListener);
    el.addEventListener('drop', this._onDropListener);
  }

  stopDefaultPropagation(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  onDragIn(e) {
    // IMPORTANT:
    // event trigger order: dragenter => dragleave => drop

    this.stopDefaultPropagation(e);
    this._dragInElm = e.target;

    // target must be listening element.
    if (e.target === this.opt.el) {
      this.opt.onDragIn.call(this, e);
    }
  }

  onDragOut(e) {
    this.stopDefaultPropagation(e);
    this._dragOutElm = e.target;

    // target must be listening element, and prevous dragenter target is listening element or outside element
    if (e.target === this.opt.el
      && (this.isSelf(this._dragInElm) || this.isOutside(this._dragInElm))) {
      this.opt.onDragOut.call(this, e);
    }
  }

  onDrop(e) {
    this.stopDefaultPropagation(e);

    let droppedFiles = [].slice.call(e.dataTransfer.files);
    this.opt.onDrop.call(this, e, droppedFiles);
  }

  isSelf(elm) {
    return this.opt.el === elm;
  }

  // is self or inside children
  isInside(elm) {
    return this.opt.el.contains(elm);
  }

  isOutside(elm) {
    return !this.opt.el.contains(elm);
  }

  destroy() {
    let el = this.opt.el;
    el.removeEventListener('dragover', this.stopDefaultPropagation);
    el.removeEventListener('drag', this.stopDefaultPropagation);
    el.removeEventListener('dragstart', this.stopDefaultPropagation);
    el.removeEventListener('dragend', this.stopDefaultPropagation);
    el.removeEventListener('dragexit', this.stopDefaultPropagation);

    el.removeEventListener('dragenter', this._onDragInListener);
    el.removeEventListener('dragleave', this._onDragOutListener);
    el.removeEventListener('drop', this._onDragOutListener);
    el.removeEventListener('drop', this._onDropListener);
  }

  static isAdvancedUpload() {
    let div = document.createElement('div');
    let isDraggable = ('draggable' in div) || ('ondragstart' in div && 'ondrop' in div);
    // The FormData interface provides a way to easily construct a set of key/value pairs
    // representing form fields and their values(including files), which can then be easily sent using the
    // XMLHttpRequest.send() method.
    let hasFormData = 'FormData' in window;
    // Detect DataTransfer API is available or not before user start trying to drag.
    // The DataTransfer object is used to hold the data that is being dragged during a drag and drop operation. 
    let hasDataTransfer = 'FileReader' in window;

    return isDraggable && hasFormData && hasDataTransfer;
  }
}